<template>
  <div class="root">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";

const { ethereum } = window;
Web3EthContract.setProvider(ethereum);

export default {
  components: {
    Header,
  },
  mounted() {
    const web3 = new Web3(ethereum);
    web3.eth.getAccounts().then(async (addr) => {
      if (addr.length !== 0) {
        this.$store.dispatch("setConnected");
      }
    });

    ethereum.on("chainChanged", () => {
      window.location.reload();
    });
    ethereum.on("accountsChanged", () => {
      window.location.reload();
    });

    ethereum.on("chainChanged", () => {
      window.location.reload();
    });

    ethereum.on("accountsChanged", () => {
      window.location.reload();
    });
  },
};
</script>

<style lang="scss">
@import "./styles/variables.scss";

body {
  margin: 0;
  background-color: $background-color;
}

.image {
  max-width: 100%;
  height: auto;
  width: auto\9; /* ie8 */
}

.root {
  width: 100%;
  background-color: $background-color;
  margin: auto;
  background: linear-gradient(
    90deg,
    rgba(58, 80, 106, 1) 30%,
    rgba(32, 136, 112, 1) 50%,
    rgba(58, 80, 106, 1) 70%
  );
}
</style>
